module.exports = __webpack_public_path__ + "img/三角形.bbea3b54.png";